export default "__VITE_ASSET__DM3SXkrb__";